export const moatItems = [
    { name: '-', value: -1 },
    { name: 'O', value: 0 },
    { name: '+', value: 1 }
];

export const trendItems = [
    { value: -1, icon: 'pi pi-arrow-down-right' },
    { value: 0, icon: 'pi pi-arrow-right' },
    { value: 1, icon: 'pi pi-arrow-up-right' }
];
